<template>
  <div
    class="all"
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-text="加载中,请稍后..."
  >
    <div class="header">
      <!-- <div class="main">
        <el-row type="flex">
          <el-col :span="3" :offset="2">
            <div class="flex-center" style="height:250px">
              <img
                src="../../../admin/assets/images/AFEOP.png"
                class="course-img"
              />
            </div>
          </el-col>
          <el-col :span="13" :offset="1">
            <div class="flex-left" style="height:250px">
              <p class="header-title">{{ tableData.title }}</p>
              <p class="header-text">{{ tableData.intro }}</p>
            </div>
          </el-col>
        </el-row>
      </div> -->
    </div>
    <div class="flex-center" style="height:0">
      <div class="box">
        <div>
          <span class="box-title">{{ homedirectory.length }}</span>
          <span class="box-tip">大章节</span>
          <el-divider direction="vertical" class="box-tip"></el-divider>
          <span class="box-title">{{ long.length }}</span>
          <span class="box-tip">节课程</span>
          <el-divider direction="vertical" class="box-tip"></el-divider>
          <span>配套练习题</span>
          <el-button
            size="mini"
            style="margin-left:10px"
            @click="onload"
            plain
            type="warning"
            >生涯规划咨询师学习资料下载</el-button
          >
        </div>
        <button class="study" @click="tostudy(id)">开始学习</button>
      </div>
    </div>
    <div class="footer">
      <div class="footer-main">
        <el-row :gutter="40">
          <el-col :span="5">
            <div class="directory">
              <div
                v-for="(item, index) in homedirectory"
                :key="index"
                class="directory-box"
                @click="select(index)"
              >
                <div class="directory-style">
                  <p class="homedirectory-title">
                    {{ item.title }}
                  </p>
                  <p>{{ item.key }}</p>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="19">
            <!-- <div class="target">
              <p>课程目标：</p>
              <span class="target-tip"
                ><img
                  src="../../../admin/assets/images/ok.png"
                  class="target-ok"
                />
                <p class="target-content">
                  培训学员的反诈宣导能力
                </p></span
              >
              <span class="target-tip"
                ><img
                  src="../../../admin/assets/images/ok.png"
                  class="target-ok"
                />
                <p class="target-content">
                  增强学员的反诈知识与技巧
                </p></span
              >
              <span class="target-tip"
                ><img
                  src="../../../admin/assets/images/ok.png"
                  class="target-ok"
                />
                <p class="target-content">
                  完善学员的反诈宣导规范
                </p></span
              >
              <span class="target-tip"
                ><img
                  src="../../../admin/assets/images/ok.png"
                  class="target-ok"
                />
                <p class="target-content">
                  提升学员的沟通能力
                </p></span
              >
              <span class="target-tip"
                ><img
                  src="../../../admin/assets/images/ok.png"
                  class="target-ok"
                />
                <p class="target-content">
                  提升学员的宣导工具使用能力
                </p></span
              >
            </div> -->
            <el-collapse v-model="leftModuleActiveNames" accordion>
              <div
                v-for="(item, index) in homedirectory"
                :key="index"
                class="homedirectory"
              >
                <el-collapse-item :title="item.title" :name="index">
                  <div
                    v-for="(e, i) in item.infos"
                    :key="i"
                    class="subdirectory"
                    @click="study(goryid, item.id, e.article.id, e.id)"
                  >
                    <el-row
                      :class="
                        item.infos.length - 1 != i ? 'footbox' : 'footboxed'
                      "
                    >
                      <el-col :span="6" :offset="1">
                        <img :src="e.article.art_photo" class="footbox-img" />
                      </el-col>
                      <el-col :span="14" :offset="1">
                        <div class="between">
                          <div class="content-tip">
                            <span>{{ e.article.art_title }}</span>
                          </div>
                          <div class="flex-center" v-if="e.is_study == 1">
                            <div class="studied"></div>
                            已学习
                          </div>
                          <div class="flex-center" v-if="e.is_study == 0">
                            <div class="unstudied"></div>
                            未学习
                          </div>
                          <div class="flex-center" v-if="e.is_study == 2">
                            <div class="studying"></div>
                            学习中
                          </div>
                        </div>
                        <p v-if="e.article.resource">
                          <span class="margin-right">课程时长:</span
                          >{{ minute(e.article.resource.length_time) }}
                        </p>
                        <p v-if="!e.article.resource">
                          视频还未上传
                        </p>
                        <div class="flex">
                          <p class="margin-right">
                            课程简介:
                          </p>
                          <span
                            v-html="e.article.art_content"
                            class="article-content"
                          ></span>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </el-collapse-item>
              </div>
            </el-collapse>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      title="支付"
      :visible.sync="dialogVisible"
      width="550px"
      v-loading="loading"
      :close-on-click-modal="false"
      center
      class="payStyle"
    >
      <div style="margin-bottom:10px">
        <span>付费内容:</span>
        培训教材、评测练习、正式评测、评测审核、证书制作、证书颁发。
      </div>
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="支付方式：">
          <el-radio v-model="payRadio" label="1" class="radio" border
            >微信支付</el-radio
          >
          <el-radio v-model="payRadio" label="2" class="radio" border
            >兑换码</el-radio
          >
        </el-form-item>
        <el-form-item label="输入兑换码：" v-if="payRadio == 2">
          <el-input v-model="redeemData"></el-input>
          <!-- <p>*请注意区分大小写</p> -->
        </el-form-item>
        <el-form-item label="支付金额：" v-else>
          {{ this.$price }}
        </el-form-item>
        <el-form-item label="推荐人：" v-if="payRadio == 1">
          <el-input v-model="remarks" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button
            type="success"
            @click="toPay"
            v-if="payRadio == 1"
            class="button"
            >立即支付</el-button
          >
          <el-button type="primary" @click="toRedeem()" class="button" v-else
            >立即兑换</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script setup>
export default {
  name: 'Course',
  data() {
    return {
      leftModuleActiveNames: 0,
      id: 1,
      tableData: {},
      homedirectory: [],
      tip: '',
      long: [],
      utip: '',
      fullscreenLoading: false,
      goryid: '',
      dialogVisible: false,
      payRadio: '1',
      loading: false,
      redeemData: '',
      redeem_number: '',
      remarks: '',
      form: {},
      disabled: false,
    }
  },
  created() {
    if (localStorage.getItem('agent_id')) {
      this.remarks = localStorage.getItem('agent_id')
      this.disabled = true
    }
  },
  mounted() {
    this.goryid = 1
    this.init()
  },
  methods: {
    toRedeem() {
      //兑换码
      let _this = this
      _this.loading = true
      let subsystem_url = window.location.href
      _this.$http
        .post(process.env.VUE_APP_URL + 'exchange', {
          clist_id: _this.goryid,
          numbers: _this.redeemData,
          subsystem_url: subsystem_url,
        })
        .then(data => {
          _this.loading = false
          if (data.data.code == 403 || data.data.code == 500) {
            _this.$message.error(data.data.msg)
            return
          }
          if (data.data.code == 200) {
            _this.dialogVisible = false
            _this.$message.success('恭喜您兑换成功!快点击课程开始学习吧!')
          }
        })
    },
    onload() {
      window.location.href =
        process.env.VUE_APP_URLPOOL + '/生涯规划咨询师题库.docx'
    },
    tostudy(cid, uid, id) {
      let _this = this
      if (_this.tip) {
        _this.$http
          .post(process.env.VUE_APP_URL + 'article/getArtinfo/' + id, {
            clist_id: _this.goryid,
          })
          .then(data => {
            if (data.data.code == 201) {
              this.dialogVisible = true
              return
            } else if (data.data.code == 403) {
              this.$message.error(data.data.msg)
            } else {
              this.dialogVisible = false
              this.$router.push({
                name: 'Videoplays',
                params: {
                  cid: _this.goryid,
                  id: _this.tip,
                  uid: _this.utip,
                },
              })
            }
          })
      }
    },
    study(cid, uid, id) {
      let _this = this
      _this.$http
        .post(process.env.VUE_APP_URL + 'article/getArtinfo/' + id, {
          clist_id: cid,
        })
        .then(data => {
          if (data.data.code == 201) {
            this.dialogVisible = true
            return
          } else if (data.data.code == 403) {
            this.$message.error(data.data.msg)
          } else {
            this.dialogVisible = false
            this.$router.push({
              name: 'Videoplays',
              params: { cid: cid, id: id, uid: uid },
            })
          }
        })
    },
    select(index) {
      this.leftModuleActiveNames = index
    },
    init() {
      let _this = this
      _this.fullscreenLoading = true
      _this.$http
        .post(process.env.VUE_APP_URL + 'article/courseBig', {
          id: this.goryid,
        })
        .then(function(data) {
          _this.fullscreenLoading = false
          if (data.data.code == 200) {
            _this.tableData = data.data.data
            _this.homedirectory = data.data.data.list
            _this.utip = _this.homedirectory[0].id
            _this.tip = _this.homedirectory[0].infos[0].article.id
            _this.homedirectory.forEach(item =>
              item.infos.forEach(e => {
                _this.long.push(e)
              })
            )
          } else {
            _this.$message.error(data.data.msg)
            return
          }
        })
        .catch(function(error) {
          console.log(error)
          _this.$message.error('网络错误，请重试')
          return
        })
    },
    minute(msd) {
      var time = msd
      if (null != time && '' != time) {
        if (time > 60 && time < 60 * 60) {
          time =
            parseInt(time / 60.0) +
            '分钟' +
            parseInt((parseFloat(time / 60.0) - parseInt(time / 60.0)) * 60) +
            '秒'
        } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
          time =
            parseInt(time / 3600.0) +
            '小时' +
            parseInt(
              (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
            ) +
            '分钟' +
            parseInt(
              (parseFloat(
                (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
              ) -
                parseInt(
                  (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
                )) *
                60
            ) +
            '秒'
        } else if (time >= 60 * 60 * 24) {
          time =
            parseInt(time / 3600.0 / 24) +
            '天' +
            parseInt(
              (parseFloat(time / 3600.0 / 24) - parseInt(time / 3600.0 / 24)) *
                24
            ) +
            '小时' +
            parseInt(
              (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
            ) +
            '分钟' +
            parseInt(
              (parseFloat(
                (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
              ) -
                parseInt(
                  (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
                )) *
                60
            ) +
            '秒'
        } else {
          time = parseInt(time) + '秒'
        }
      }
      return time
    },
    toPay() {
      let _this = this
      let subsystem_url = window.location.href
      _this.$http
        .post(process.env.VUE_APP_URL + 'order', {
          good_id: 1,
          subsystem_url: subsystem_url,
          remarks: _this.remarks,
        })
        .then(data => {
          if (data.data.code == 200) {
            //未付款
            _this.order_number = data.data.data
            window.location.href =
              'http://pay.netban.cn/pay/' + this.order_number //跳转至支付页面
          } else {
            _this.$message.error(data.data.msg)
          }
        })
        .catch(err => {
          _this.$message.error('网络错误，请重试')
          console.log(err)
        })
    },
  },
}
</script>

<style lang="less" scoped>
.all {
  width: 100%;
}
.header {
  background-color: #fd4a29;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
}
.main {
  width: 1200px;
  height: 250px;
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex-left {
  display: flex;
  align-items: left;
  justify-content: center;
  flex-direction: column;
}
.header-title {
  color: #ffffff;
  font-size: 25px;
  margin-bottom: 20px;
  letter-spacing: 3px;
  font-weight: 600;
}
.header-text {
  color: #ffffff;
  font-size: 13px;
  line-height: 25px;
  letter-spacing: 1px;
}
.box {
  width: 1080px;
  height: 60px;
  position: relative;
  border-radius: 10px;
  padding: 0 40px 0 60px;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  margin-left: 40px;
}
.box-title {
  color: #fd4a29;
  font-size: 20px;
  letter-spacing: 5px;
  width: 40px;
}
.box-titled {
  color: #fd4a29;
  width: 40px;
}
.box-titlet {
  color: #fd4a29;
  font-size: 20px;
  width: 40px;
  margin-right: 5px;
}
.study {
  background-color: #fd4a29;
  border-radius: 5px;
  color: #ffffff;
  border: inherit;
  height: 40px;
  width: 100px;
  cursor: pointer;
}
.box-tip {
  margin-right: 25px;
}
.footer {
  width: 100%;
  background-color: #f0f0f0;
  display: flex;
  justify-content: center;
}
.footer-main {
  width: 1160px;
  margin-left: 40px;
  padding-top: 60px;
}
.directory {
  width: 220px;
  border: 1px solid #b4b4b4;
  font-size: 12px;
  border-radius: 5px;
  background-color: #ffffff;
}
.directory-box {
  width: 220px;
  padding: 16px 0 15px 0;
  border-bottom: 1px solid #e6e6e6;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.directory-style {
  display: flex;
  flex-direction: column;
  padding-left: 16px;
}
.directory-box p {
  font-size: 13px;
}
.directory-style:hover {
  display: flex;
  flex-direction: column;
  border-left: 2px solid #fd4a29;
  padding-left: 14px;
}
.homedirectory-title {
  margin-bottom: 2px;
}
.target {
  width: 840px;
  height: 90px;
  border: 1px solid #b0b0b0;
  padding: 20px 40px 20px 40px;
  border-radius: 10px;
}
.homedirectory {
  //   width: 920px;
  //   margin: 30px 0 30px 0;
  cursor: pointer;
  //   border-radius: 10px 10px 10px 10px;
}
.footbox {
  border-bottom: 1px solid #b0b0b0;
  border-left: 1px solid #b0b0b0;
  border-right: 1px solid #b0b0b0;
  padding: 15px 5px 15px 20px;
}
.footboxed {
  border-bottom: 1px solid #b0b0b0;
  border-left: 1px solid #b0b0b0;
  border-right: 1px solid #b0b0b0;
  padding: 15px 5px 15px 20px;
  border-radius: 0 0 10px 10px;
}
.footboxed p {
  margin-top: 10px;
}
.footbox p {
  margin-top: 10px;
}
/deep/.el-collapse-item__content {
  padding-bottom: inherit;
  font-size: inherit;
  line-height: inherit;
}
/deep/.el-collapse-item__header {
  height: 60px;
  padding: 0 0 0 60px;
  font-size: 18px;
  font-weight: 600;
  border-top: 1px solid #b0b0b0;
  border-left: 1px solid #b0b0b0;
  border-right: 1px solid #b0b0b0;
}
.footbox-img {
  width: 100%;
}
.between {
  display: flex;
  justify-content: space-between;
}
.content-tip {
  margin-right: 20px;
  font-size: 16px;
  font-weight: 600;
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.course-img {
  width: 140px;
  height: 132px;
}
.studied {
  height: 16px;
  width: 16px;
  background-color: #112cef;
  border: 1px #112cef solid;
  border-radius: 50%;
  margin-right: 6px;
}
.unstudied {
  height: 16px;
  width: 16px;
  border: 1px saddlebrown solid;
  border-radius: 50%;
  margin-right: 6px;
}
.studying {
  height: 16px;
  width: 16px;
  background-color: saddlebrown;
  border: 1px saddlebrown solid;
  border-radius: 50%;
  margin-right: 6px;
}
.weight {
  font-weight: 600;
}
.margin-right {
  margin-right: 5px;
}
.margin-left {
  margin-left: 10px;
}
.article-content {
  width: 440px;
  margin-top: 10px;
}
.margin-right-brief {
  margin-right: 38px;
}
.target-ok {
  width: 15px;
  height: 15px;
  margin-right: 5px;
  vertical-align: text-bottom;
}

.target span {
  display: inline-block;
  width: 280px;
  font-size: 14px;
  margin-top: 16px;
}
.target-content {
  display: inline;
  font-size: 13px;
}
/deep/.el-collapse-item__header {
  border-bottom: 1px solid #b0b0b0;
  border-radius: 10px 10px 0 0;
}
// .el-collapse-item is-active{
//     border-radius: 10px;
// }
/deep/.el-collapse-item__wrap {
  border-radius: 0 0 10px 10px;
}
.warnRed {
  margin-top: 8px;
}
.redeem {
  padding: 10px 10px 0 0;
}
.button {
  padding: 8px 16px;
  margin-top: 10px;
}
.radio {
  padding: 6px 10px 0 6px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  height: 29px;
  margin-left: 10px;
}
</style>
